import { Modal } from '@pmi/dsm-react';
import { ArrowForwardIcon } from '@pmi/dsm-react/dist/components/icons/24';
import RenderHtml from '../RenderHtml';

function AssignProductsConfirmModal({
  onClose,
  onContinue,
  productName,
}: {
  onClose: () => void;
  onContinue: () => void;
  productName: string;
}) {
  const handleContinue = () => {
    onContinue();
    onClose();
  };
  return (
    <Modal
      show
      onClose={onClose}
      buttons={[
        {
          titleText: 'Cancel',
          onClick: onClose,
          variant: 'outline-secondary',
          size: 'sm',
        },
        {
          titleText: 'Assign Products',
          variant: 'primary',
          onClick: handleContinue,
          icon: ArrowForwardIcon,
          iconAlign: 'right',
          size: 'sm',
        },
      ]}
    >
      <div className="p-3">
        <h4 className="mb-2">Duplicate product assignment warning</h4>
        <p>
          One or more user already are assigned{' '}
          <RenderHtml html={productName} tag="span" /> are you sure you would
          like to continue with this assignment?
        </p>
      </div>
    </Modal>
  );
}

export default AssignProductsConfirmModal;
